require('./angular-resource');
module.exports = 'ngResource';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-resource/index.js
 ** module id = 778
 ** module chunks = 8
 **/